angular.module 'services', [
  "services.editorNavSections",
  "services.layoutEditor",
  "services.animations",
  "services.tutorials"
]





// WEBPACK FOOTER //
// ./src/app/editor/services/main.coffee